module.exports = __webpack_public_path__ + "img/trash-can-undo.8f910c56.svg";